import { FeedbackFormData } from 'mk2/apps/wiki/components/FeedbackForm';
import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// Article load

export const ARTICLE_FETCH_TRIGGER = 'ARTICLE_FETCH_TRIGGER';
export interface ArticleFetchTriggerAction {
    readonly type: typeof ARTICLE_FETCH_TRIGGER;
    readonly articleSlug: string;
    readonly categorySlug: string;
}
export const ARTICLE_FETCH_REQUEST = 'ARTICLE_FETCH_REQUEST';
export interface ArticleFetchRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_FETCH_REQUEST;
    readonly articleSlug: string;
    readonly categorySlug: string;
}
export interface ArticleFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { article: number };
}
export const ARTICLE_FETCH_SUCCESS = 'ARTICLE_FETCH_SUCCESS';
export interface ArticleFetchSuccessAction extends APISuccessAction<ArticleFetchNormalizedResponse> {
    readonly type: typeof ARTICLE_FETCH_SUCCESS;
    readonly articleSlug: string;
    readonly categorySlug: string;
}
export const ARTICLE_FETCH_FAILURE = 'ARTICLE_FETCH_FAILURE';
export interface ArticleFetchFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_FETCH_FAILURE;
    readonly articleSlug: string;
    readonly categorySlug: string;
}

export const articleFetchTrigger =
    (articleSlug: string, categorySlug: string): ArticleFetchTriggerAction => ({
        type: ARTICLE_FETCH_TRIGGER, articleSlug, categorySlug,
    });
export const articleFetchApi = {
    request: (articleSlug: string, categorySlug: string): ArticleFetchRequestAction => ({
        type: ARTICLE_FETCH_REQUEST, articleSlug, categorySlug,
    }),
    success: (articleSlug: string, categorySlug: string, response: ArticleFetchNormalizedResponse): ArticleFetchSuccessAction => ({
        type: ARTICLE_FETCH_SUCCESS, articleSlug, categorySlug, response,
    }),
    failure: (articleSlug: string, categorySlug: string, error: any): ArticleFetchFailureAction => ({
        type: ARTICLE_FETCH_FAILURE, articleSlug, categorySlug, error,
    }),
};

// ///////////////////////////////////////////////////////////////////
// Feedback Submit

export const FEEDBACK_SUBMIT = 'FEEDBACK_SUBMIT';
export interface FeedbackSubmitAction {
    readonly type: typeof FEEDBACK_SUBMIT;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly feedbackFd: FeedbackFormData;
}

export const feedbackSubmit = (articleSlug: string, categorySlug: string, feedbackFd: FeedbackFormData): FeedbackSubmitAction => ({
        type: FEEDBACK_SUBMIT, articleSlug, categorySlug, feedbackFd,
    });

// Action for not authenticated users
export const WIKI_ARTICLE_ADD_EXPERIENCE = 'WIKI_ARTICLE_ADD_EXPERIENCE';

export interface WikiArticleAddExperienceAction extends Action {
    readonly type: typeof WIKI_ARTICLE_ADD_EXPERIENCE;
}

export const wikiArticleAddExperience = (): WikiArticleAddExperienceAction => ({
    type: WIKI_ARTICLE_ADD_EXPERIENCE,
});
